import React, { useState } from 'react';
import Datatable from '../../components/shared/datatable/Datatable';
import { formatDateToMDY, showToast } from '../../helpers/Utils';
import { Image } from 'react-bootstrap';
import Button from '../../components/shared/buttons/button';
import { MdOutlineEditNote } from 'react-icons/md';
import { MdDeleteOutline } from 'react-icons/md';
import CreateLinkModal from '../../components/shared/modalContent/CreateLinkModal ';
import { useGetAllReviewLinksQuery ,useDeleteReviewLinkMutation} from '../../app/reviewLinksApi/reviewLinksApi';
import CommonDeleteModal from '../../components/shared/modalContent/CommonDeleteModal';
import { Link } from 'react-router';
import { PhotoProvider, PhotoView } from 'react-photo-view';
const ReviewLinks = () => {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [showCreateLinkModal, setShowCreateLinkModal] = useState(false);
    const [showCommonDeleteModal, setShowCommonDeleteModal] = useState(false);
    const [reviewLinkId, setReviewLinkId] = useState(null)
    const { data, isLoading, refetch } = useGetAllReviewLinksQuery({ page, search });
    console.log(data,"data");
    
    const [deleteProduct, { isLoading: isDeleting }] = useDeleteReviewLinkMutation();

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handleSearch = (value) => {
        setSearch(value);
    };



    const handleDelete = async () => {       
            try {
                await deleteProduct(reviewLinkId).unwrap();
                showToast('Product deleted successfully', 'success');
                setShowCommonDeleteModal(false)
                refetch();
            } catch (error) {
                showToast(error?.data?.message || 'Something went wrong', 'error');
            }
       
    };

    const columns = [
        {
            label: 'link image',
            accessor: 'review_image',
            cell: ({ row }) => (
               
                  <PhotoProvider>
                    <PhotoView   src={row?.review_image}>
                        <Image
                              src={row?.review_image}
                            alt={row?.product_name}
                            width={60}
                            height={60}
                            rounded
                        />
                    </PhotoView>

                </PhotoProvider>
            ),
        },
       
        {
            label: 'Review Link',
            accessor: 'review_link',
            cell: ({ row }) => (<>
                <Link to={row?.review_link} target='_blank'>{row?.review_link} </Link>
            </>),
        },
        {
            label: 'Review Text',
            accessor: 'text',
        
        },
       
        {
            label: 'Created At',
            accessor: 'createdAt',
            cell: ({ row }) => formatDateToMDY(row?.createdAt),
        },
        {
            label: 'Updated At',
            accessor: 'updatedAt',
            cell: ({ row }) => formatDateToMDY(row?.updatedAt),
        },
        {
            label: 'Action',
            accessor: 'action',
            cell: ({ row }) => (
                <div className='d-flex gap-3'>
                    <Button
                        className={'borderedBtn px-0'}
                        size="xs"
                        icon={<MdOutlineEditNote size={20} />}
                        onClick={() => { setReviewLinkId(row?._id); setShowCreateLinkModal(true) }}
                    />
                    <Button
                        className={'borderedBtn px-0'}
                        size="xs"
                        icon={<MdDeleteOutline size={20} />}
                        onClick={() => {  setReviewLinkId(row?._id); setShowCommonDeleteModal(true) }}
                        disabled={isDeleting}
                    />
                </div>
            ),
        },
    ];

    return (
        <>
           <CreateLinkModal show={showCreateLinkModal} setShow={setShowCreateLinkModal} reviewLinkId={reviewLinkId}  />
           <CommonDeleteModal show={showCommonDeleteModal} setShow={setShowCommonDeleteModal} onSucces={handleDelete} title={'Are you sure you want to delete review link'} />

            <div className='d-flex gap-3 justify-content-between align-items-center mb-3'>
                <h5 className='home-title'>Review Links</h5>
                <Button
                    label={'Create Link'}
                    onClick={() => {
                        setReviewLinkId(null);
                        setShowCreateLinkModal(true);
                    }}
                />
            </div>

            <Datatable
                tableData={data || []}
                columns={columns}
                page={page}
                onPageChange={handlePageChange}
                isLoading={isLoading}
                showPegination={true}
                showFilter={false}
                onFilterSearch={handleSearch}
            />
        </>
    );
};

export default ReviewLinks;
